export default __webpack_public_path__ + "static/media/piopio.2cc91435.jpg";